<template>
  <Modal :show="show">
    <div class="rule-model">
      <div class="rule-title">活动规则</div>
      <div class="rule-desc">
        <div v-html="activityExplain"></div>
      </div>
      <div @click="onCloseRule" class="rule-btn">知道了</div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../../components/modal/index.vue'

export default {
  components: {
    Modal
  },
  model: {
    prop: 'show',
    event: 'update:show'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    activityExplain: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    onCloseRule() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.rule-model {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 375px;
  background: #ffffff;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  background: #fff;
}

.rule-title {
  line-height: 52px;
  height: 52px;
  background: #fc4c44;
  border-radius: 15px 15px 0 0;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
}

.rule-desc {
  width: 300px;
  height: 260px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
  padding: 20px 13px 15px 13px;
  box-sizing: border-box;
  font-weight: 500;
  overflow-y: scroll;
}

.rule-btn {
  width: 200px;
  height: 40px;
  line-height: 40px;
  background: #fc4c44;
  border-radius: 20px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  margin: auto;
}
</style>
